import { call, put, takeLatest } from 'redux-saga/effects'
import { getAllCallLogs, makeCall, getCallStatus } from './callLog.reducer'
import Api from '../services/ApiCaller'

export function* getAllCallLogsRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(getAllCallLogs.success(res))
    } else {
      yield put(getAllCallLogs.failure(message))
    }
  } catch (e) {
    yield put(getAllCallLogs.failure(e.message))
  }
}

export function* makeCallRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(makeCall.success(res))
    } else {
      yield put(makeCall.failure(message))
    }
  } catch (e) {
    yield put(makeCall.failure(e.message))
  }
}

export function* getCallStatusRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload)
    const { error } = res
    if (!error) {
      yield put(getCallStatus.success(res))
    }
  } catch (e) {
    yield put(getCallStatus.failure(e.message))
  }
}

interface IidData {
  id: number
}
export default (api: any) => {
  const getAllCallLogsApi = (data: IidData) => api.get(`/calls/${data.id}`, data)
  const makeCallApi = (data: IidData) => api.post(`/calls/${data.id}`, data)
  const getCallStatusApi = (data: any) => api.get(`/calls/${data.patientId}/${data.id}`, {})
  return [
    takeLatest(getAllCallLogs.TRIGGER, getAllCallLogsRequest, getAllCallLogsApi),
    takeLatest(makeCall.TRIGGER, makeCallRequest, makeCallApi),
    takeLatest(getCallStatus.TRIGGER, getCallStatusRequest, getCallStatusApi)
  ]
}
